import React from 'react'
import { NavLink } from 'react-router-dom'

const AdminSidebar = () => {
  const menuItems = [
    { path: '/admin', label: 'Дашборд', icon: '📊' },
    { path: '/admin/tours', label: 'Туры', icon: '✈️' },
    { path: '/admin/cruises', label: 'Круизы', icon: '🚢' },
    { path: '/admin/applications', label: 'Заявки', icon: '📝' },
    { path: '/admin/contract-editor', label: 'Редактор договоров', icon: '📄' },
  ]

  return (
    <aside style={{
      width: '250px',
      backgroundColor: 'white',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      minHeight: 'calc(100vh - 64px)'
    }}>
      <nav style={{ padding: '1rem' }}>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 1rem',
              borderRadius: '0.5rem',
              marginBottom: '0.5rem',
              textDecoration: 'none',
              color: isActive ? '#3b82f6' : '#4b5563',
              backgroundColor: isActive ? '#eff6ff' : 'transparent',
              transition: 'all 0.2s'
            })}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}

export default AdminSidebar